export default __webpack_public_path__ + "resources/icons/n140-08e7.png";